// From "antd" (not antd/lib), so the theme set in src/common/theme-mode reaches these toasts. Colours are
// variables with the light value as the fallback, so ADEED dark mode can darken them (src/index.css).
import { notification } from "antd";

class Notification {
    success(title, text) {
        notification.success({
            message: <span style={{ color: "var(--toast-success-text, #0C9E42)",fontWeight:"600",opacity:"0.8" }}>{title}</span>,
            description: <span style={{ color: "var(--toast-success-text, #0C9E42)",fontWeight:"600",opacity:"0.8" }}>{text}</span>,
            duration: 3,
            style: {
                borderRadius: 11,
                backgroundColor: "var(--toast-success-bg, #EDF9F0)",
            },
        });
    }

    error(title, text) {
        notification.error({
            message: <span style={{ color: "var(--toast-error-text, #FF0606)",fontWeight:"600",opacity:"0.8" }}>{title === 'error' ? 'Error!' : title}</span>,
            description: <span style={{ color: "var(--toast-error-text, #FF0606)",fontWeight:"600",opacity:"0.8" }}>{text}</span>,
            duration: 5,
            style: {
                borderRadius: 11,
                backgroundColor: "var(--toast-error-bg, #FEEFEF)",
            },
        });
    }

    warning(title, text) {
        notification.warning({
            message: <span style={{ color: "var(--toast-warning-text, inherit)",fontWeight:"600",opacity:"0.8" }}>{title}</span>,
            description: <span style={{ color: "var(--toast-warning-text, inherit)",fontWeight:"600",opacity:"0.8" }}>{text}</span>,
            duration: 5,
            style: {
                borderRadius: 11,
                backgroundColor: "var(--brand-50, #FFF4EC)",
            },
        });
    }
}

export default new Notification();